<ul
  class="navbar-nav nav-primary nav"
  id="navPrimary"
  itemscope
  itemtype="http://www.schema.org/SiteNavigationElement"
  role="tablist"
>
  <li
    role="none"
    [ngClass]="{
      'active-menu': selectedNav === 'book' && !isSlimHeader && isHome
    }"
    class="nav-item app-link-item d-lg-none"
  >
    <a
      role="tab"
      class="nav-link app-link d-lg-none"
      href="/home"
      id="navBarHomeLink"
    >
      HOME
    </a>
  </li>
  <li
    *ngFor="let navItem of mainNav; let i = index"
    [ngClass]="{
      'active-menu': selectedNav === navItem.id && !isSlimHeader,
      'active-menu-blue': isSlimHeader
    }"
    class="nav-item app-link-item"
    itemprop="name"
    role="none"
  >
    <a
      (click)="
        setTrackingObject(navItem.id, $event);
        primaryNavClicked(
          navItem.id,
          navItem.details?.legacyAppUrl,
          navItem.redirectMobile,
          navItem.redirectMobileUrl
        );
        prevPrimaryNav = navItem.id
      "
      (focus)="selectedSecNav = null"
      (keydown)="
        KeyEventOnPrimaryNav(
          $event,
          navItem.id,
          navItem.details?.legacyAppUrl,
          navItem.redirectMobile,
          navItem.redirectMobileUrl
        )
      "
      [attr.aria-controls]="'primaryPanel' + (i + 1)"
      [attr.aria-selected]="selectedNav === navItem.id"
      [attr.id]="'headPrimary' + (i + 1)"
      [attr.tabindex]="selectedNav === navItem.id || inMobile ? '0' : '-1'"
      class="nav-link app-link nav-link-{{ navItem.label | trim | lowercase }}"
      href="{{ navItem.searchUrl }}"
      itemprop="url"
      role="tab"
    >
      {{ navItem.label }}
    </a>

    <!-- <a role="menuitem" itemprop="url" href="javascript:void(0);" class="nav-link app-link d-block d-md-none nav-link-{{ navItem.label | trim | lowercase }}" [attr.aria-expanded]="selectedNav === navItem.id" (click)="setTrackingObject(navItem.id, $event); selecedtNavItem(navItem.id, $event); prevPrimaryNav=navItem.id;"
            *ngIf="navItem.id === 'flightstatus'">{{navItem.label}}</a> -->
  </li>
  <li
    *ngFor="let secNavItem of secondaryNav; let i = index"
    [ngClass]="{
      'first-static-link': i === 0,
      'last-static-link': i === 2,
      'active-menu': selectedSecNav === secNavItem.id
    }"
    class="nav-item staticLink"
    dropdown
    ngc-openshow
    role="none"
  >
    <a
      (click)="setTrackingObject(secNavItem.id, $event)"
      (keydown)="KeyEventOnSecondaryNav($event, secNavItem.id)"
      (mouseout)="mouseOutSecLinks()"
      (mouseover)="mouseHoverSecLinks($event, secNavItem.id)"
      [attr.aria-controls]="'secPanel' + (i + 1)"
      [attr.aria-selected]="selectedSecNav === secNavItem.id"
      [attr.id]="'headSectab' + (i + 1)"
      [attr.tabindex]="selectedSecNav === secNavItem.id ? '0' : '-1'"
      class="nav-link static-link d-none d-lg-block static-link-{{
        secNavItem.id | trim | lowercase
      }}"
      href="javascript:void(0);"
      role="tab"
    >
      {{ secNavItem.label }}
    </a>
    <div
      *ngIf="!inMobile && selectedSecNav === secNavItem.id"
      [attr.aria-labelledby]="'headSectab' + (i + 1)"
      [attr.id]="'secPanel' + (i + 1)"
      [ngClass]="{ secLinkHoverTriggered: secLinkHoverTriggered }"
      class="widget-container-lg nav-content-outlet bg-dark main-container sec-links"
      role="tabpanel"
      style="
        position: absolute;
        left: 0;
        width: 100%;
        margin-top: 3px;
        z-index: 9999;
      "
    >
      <ngc-app-sec-links-content
        [navbarSecondaryLink]="secNavItem.id"
      ></ngc-app-sec-links-content>
    </div>
    <a
      (click)="setTrackingObject(secNavItem.id, $event)"
      [attr.aria-expanded]="selectedSecNav === secNavItem.id"
      aria-selected="false"
      class="nav-link icon-Dropdown-caret static-link d-block d-lg-none static-link-{{
        secNavItem.id | trim | lowercase
      }}"
      dropdownToggle
      href="javascript:void(0);"
      role="tab"
    >
      {{ secNavItem.label }}
      <span class="float-right navColumnHedingArrow"></span>
    </a>
    <div class="dropdown-menu">
      <ngc-app-sec-links-content
        *ngIf="inMobile"
        [navbarSecondaryLink]="secNavItem.id"
        class="container-fluid bg-dark main-container"
      ></ngc-app-sec-links-content>
    </div>
  </li>
</ul>
